import { cx } from "@emotion/css";
import { useTranslation } from "react-i18next";
import routing from "routing";
import PickerItems from "src/images/Icons/newIcons/itemsList.svg";
import FlashcardIcon from "src/images/Icons/newIcons/navigation/flashcards.svg";
import PickerNewItem from "src/images/Icons/newIcons/newItem.svg";

import { Header } from "../../../Main/ExamsBox/ExamsBox";
import { DefaultPicker } from "./DefaultPicker";

function FlashcardsPicker() {
	const { t } = useTranslation();

	return (
		<DefaultPicker
			Header={
				<Header
					title={t("contentPicker.flashcards.title")}
					icon={<FlashcardIcon className={cx("icon-super-big icon-purple")} />}
					withBackButton
				/>
			}
			boxes={[
				{
					title: t("contentPicker.flashcards.create.title"),
					subtitle: t("contentPicker.flashcards.create.subtitle"),
					path: routing.paths.pickFlashcardsDeckChoice,
					submitText: t("commands.create"),
					Icon: PickerNewItem,
				},
				{
					title: t("contentPicker.flashcards.list.title"),
					subtitle: t("contentPicker.flashcards.list.subtitle"),
					path: routing.paths.userDecks,
					submitText: t("commands.browse"),
					Icon: PickerItems,
				},
			]}
		/>
	);
}

export default FlashcardsPicker;
